import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Colors from "../../../constants/Colors";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CountUp from "react-countup";
import IconButton from "@material-ui/core/IconButton";
import NoteIcon from "@material-ui/icons/Assignment";
import StarsIcon from "@material-ui/icons/Stars";
import ChatIcon from "@material-ui/icons/Chat";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";

import NotesModal from "./NotesModal";
import NotifsModal from "./NotifsModal";

import { connect } from "react-redux";
import {
  selectTab,
  changeField,
  submitComment,
  getManagerCommentsRequest,
  getAllManagerSurveysRequest,
  createManagerSurveyRequest,
  modifyManagerSurveyRequest
} from "../../../services/manager/actions";
import GoalsModal from "./GoalsModal";
moment.locale("fr");

const styles = theme => ({
  main: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  leftDiv: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    height: "100%"
    // height: "calc(100% - 40px)"
    // minHeight: 500
  },
  rightContainer: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  rightDiv: {
    minHeight: "-webkit-min-content",
    height: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: Colors.backGrey,
    flex: 4
    // height: "calc(100% - 40px)"
  },
  picture: {
    // objectFit: "contain",
    // maxHeight: 250,
    maxHeight: 275,
    // width: 250,
    // borderRadius: 125,
    // marginTop: 15,
    // height: "100%",
    width: "100%"
  },
  topLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  bottomLeft: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "column",
    padding: 10
  },
  name: {
    fontWeight: 500,
    marginTop: 15
  },
  rank: {
    fontWeight: 500,
    color: Colors.pink
  },
  totalDone: {
    color: Colors.lightBlue,
    fontWeight: 500
  },
  profileStats: {
    marginTop: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%"
  },
  totalDoneDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  rangDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  legend: {
    // color: Colors.mediumGrey,
    color: Colors.blackGrey,
    opacity: 0.25
  },
  suggestions: {
    width: "90%",
    marginTop: 10,
    padding: 10,
    backgroundColor: Colors.blackGrey,
    borderRadius: 8,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  suggestionText: {
    textAlign: "center",
    color: "#fff"
  },
  italic: {
    fontStyle: "italic"
  },
  textField: {
    borderRadius: 30
  },
  suggestionDiv: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // justifyContent: "flex-end",
    flex: 1
  },
  title: {
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15
  },
  commentDiv: {},
  firstSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "flex-start",
    display: "flex"
  },
  paper: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    backgroundColor: "#fff",
    // marginTop: 30,
    height: 250,
    padding: 10,
    width: "90%",
    // padding: 5,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center"
  },
  firstSectionLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: 1
  },
  firstSectionRight: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  },
  repartition: {
    height: 100,
    display: "flex",
    marginTop: 15
  },
  container: {
    height: "100%"
  },
  button: {
    alignSelf: "center"
  },
  closeButton: {
    zIndex: 10,
    position: "absolute",
    top: 1,
    right: 1
  },
  minDiv: {
    width: 300,
    minWidth: 100
  },
  buttonDiv: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex"
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
});

class LeftUserProfile extends Component {
  state = {
    isNotesModalVisible: false,
    isGoalsModalVisible: false,
    isNotifsModalVisible: false
  };

  formatFeelingEvolution = feelingEvolution => {
    let data = [];
    feelingEvolution.forEach(el => {
      const month = moment(el.date).format("MMMM");
      const monthIndex = data.findIndex(dataEl => dataEl.mois === month);
      if (monthIndex > -1) {
        data[monthIndex].users++;
        data[monthIndex].Stress += el.stress;
        data[monthIndex].Confiance += el.confidence;
        data[monthIndex]["Aisance à l'oral"] += el.publicSpeaking;
        data[monthIndex]["Cohésion d'équipe"] += el.teamCohesion;
        data[monthIndex]["Productivité"] += el.productivity;
      } else {
        const newData = {
          mois: month,
          monthNumber: moment(el.date).month(),
          users: 1,
          Stress: el.stress,
          Confiance: el.confidence,
          "Aisance à l'oral": el.publicSpeaking,
          "Cohésion d'équipe": el.teamCohesion,
          Productivité: el.productivity
        };
        data.push(newData);
      }
    });
    return data;
  };

  formatFirstFeeling = stats => {
    const result = [
      {
        title: "Stress",
        "Situation initiale": 0
      },
      {
        title: "Confiance",
        "Situation initiale": 0
      },
      {
        title: "Cohésion d'équipe",
        "Situation initiale": 0
      },
      {
        title: "Aisance à l'oral",
        "Situation initiale": 0
      }
    ];
    result[0]["Situation initiale"] = stats.stress;
    result[1]["Situation initiale"] = stats.confidence;
    result[2]["Situation initiale"] = stats.teamCohesion;
    result[3]["Situation initiale"] = stats.publicSpeaking;
    result.forEach(el => {
      el["Objectif"] = 9;
    });
    return result;
  };

  handleChange = name => event => {
    let value = event.target.value;
    this.props.changeField({
      [name]: value
    });
  };

  onChangeAdditionalNotes = event => {
    let value = event.target.value;
    let managerSurvey = { ...this.props.managerSurvey, additionalNotes: value };
    this.props.changeField({ managerSurvey });
  };

  displayNotes = () => {
    this.props.getAllManagerSurveysRequest({
      userId: this.props.userSelected._id,
      managerId: this.props.userId
    });
    this.setState({ isNotesModalVisible: true });
  };

  displayGoals = () => {
    this.setState({ isGoalsModalVisible: true });
  };

  displayNotifs = () => {
    this.setState({ isNotifsModalVisible: true });
  };

  closeComments = () => {
    this.setState({ isNotesModalVisible: false });
  };

  closeGoals = () => {
    this.setState({ isGoalsModalVisible: false });
  };

  closeNotifs = () => {
    this.setState({ isNotifsModalVisible: false });
  };

  onSaveManagerSurvey = () => {
    if (!this.props.managerSurvey._id) {
      this.props.createManagerSurveyRequest({
        userId: this.props.userSelected._id,
        managerId: this.props.userId,
        survey: this.props.managerSurvey
      });
    }
    this.props.modifyManagerSurveyRequest({
      surveyId: this.props.managerSurvey._id,
      survey: this.props.managerSurvey
    });
  };

  render() {
    const { classes, userSelected } = this.props;
    const {
      picture,
      firstName,
      lastName,
      totalDoneActions,
      jobFunction,
      rank,
      feelingEvolution,
      stats,
      bio,
      jobDescription
    } = userSelected;

    return (
      <div className={classes.leftDiv}>
        <NotesModal
          isVisible={this.state.isNotesModalVisible}
          onClose={this.closeComments}
        />
        <GoalsModal
          isVisible={this.state.isGoalsModalVisible}
          onClose={this.closeGoals}
        />
        <NotifsModal
          isVisible={this.state.isNotifsModalVisible}
          onClose={this.closeNotifs}
        />

        <div className={classes.topLeft}>
          <img src={picture} alt={firstName} className={classes.picture} />
          {/* <p>{`${firstName} ${lastName}`}</p> */}
          <Typography
            variant="h6"
            classes={{ root: classes.name }}
          >{`${firstName} ${lastName}`}</Typography>
          {jobDescription && <Typography>{`${jobDescription}`}</Typography>}
          {bio && <Typography>{`${bio}`}</Typography>}
          {/* <Typography>Stagiaire finance</Typography> */}
          <div className={classes.profileStats}>
            <div className={classes.totalDoneDiv}>
              <Typography
                align="center"
                variant="h6"
                classes={{ root: classes.totalDone }}
              >
                <CountUp
                  end={totalDoneActions}
                  duration={3}
                  start={0}
                  delay={0.1}
                />
              </Typography>
              <Typography classes={{ root: classes.legend }}>Défis</Typography>
            </div>
            <div className={classes.rangDiv}>
              <Typography
                align="center"
                variant="h6"
                classes={{ root: classes.rank }}
              >
                {rank}
              </Typography>
              <Typography classes={{ root: classes.legend }}>Rang</Typography>
            </div>
          </div>
        </div>
        <div className={classes.bottomLeft}>
          {/* <div className={classes.suggestionDiv}>
            <div className={classes.suggestions}>
              <Typography classes={{ root: classes.suggestionText }}>
                A-t-il pu progresser ?
              </Typography>
              <Typography classes={{ root: classes.suggestionText }}>
                Qu’a-t-il pensé de l’équipe ?
              </Typography>
              <Typography classes={{ root: classes.suggestionText }}>
                Quels sont ses besoins en formations ?
              </Typography>
            </div>
          </div> */}
          <div className={classes.commentDiv}>
            <div className={classes.buttonDiv} style={{ marginBottom: 16 }}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                className={classes.button}
                onClick={this.displayNotifs}
              >
                <ChatIcon className={classes.leftIcon} />
                Encourager
              </Button>
            </div>
            <div className={classes.buttonDiv} style={{ marginBottom: 16 }}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                className={classes.button}
                onClick={this.displayGoals}
              >
                <StarsIcon className={classes.leftIcon} />
                Établir des objectifs
              </Button>
            </div>
            <div className={classes.buttonDiv}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                className={classes.button}
                onClick={this.displayNotes}
              >
                <NoteIcon className={classes.leftIcon} />
                Voir mes notes
              </Button>
            </div>
            <TextField
              id="outlined-multiline-flexible"
              label="Écrire des notes additionnelles..."
              multiline
              fullWidth
              // rowsMax="4"
              value={this.props.managerSurvey.additionalNotes}
              onChange={this.onChangeAdditionalNotes}
              margin="normal"
              variant="outlined"
            />
            <Button
              fullWidth
              onClick={this.onSaveManagerSurvey}
              disabled={!this.props.managerSurvey.additionalNotes}
              variant="contained"
              color="primary"
            >
              Sauvegarder mes notes
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { userSelected, managerSurvey } = state.manager;
  const { userId } = state.client;
  return {
    userId,
    userSelected,
    managerSurvey
  };
};

export default withStyles(styles)(
  connect(mapStateToProps, {
    changeField,
    submitComment,
    getManagerCommentsRequest,
    getAllManagerSurveysRequest,
    createManagerSurveyRequest,
    modifyManagerSurveyRequest
  })(LeftUserProfile)
);
